<i18n locale="en">
{
  "done": "Done",
  "labels": {
    "description": "Description",
    "icon": "Icon",
    "title": "Title"
  },
  "placeholders": {
    "description": "Aa",
    "title": "Aa"
  }
}
</i18n>

<template>
  <EditorLayout>
    <div class="flex-col gap-8">
      <OwnInputContainer
        :label="t('labels.title')"
        :errors="title.status.errors"
        :max-chars="websiteSectionMaxChars(MAX_TITLE_LENGTH)"
        :value="title.value"
      >
        <OwnInput
          v-model="title.value"
          :placeholder="t('placeholders.title')"
        />
      </OwnInputContainer>
      <OwnInputContainer
        :label="t('labels.description')"
        :errors="description.status.errors"
        :max-chars="websiteSectionMaxChars(MAX_DESCRIPTION_LENGTH)"
        :value="description.value"
      >
        <OwnTextarea
          v-model="description.value"
          :placeholder="t('placeholders.description')"
        />
      </OwnInputContainer>

      <OwnInputContainer
        :label="t('labels.icon')"
        :errors="icon.status.errors"
        :value="icon.value"
      >
        <IconPicker v-model="icon.value" :icons="icons" />
      </OwnInputContainer>
    </div>

    <template #actions>
      <OwnButton
        :disabled="!isFormValid"
        :text="t('done')"
        variant="primary"
        @click="$emit('back')"
      />
    </template>
  </EditorLayout>
</template>

<script>
import { useI18n } from 'vue-i18n'

import IconPicker from '@/components/inputs/IconPicker.vue'
import {
  websiteSectionMaxChars,
  WebsiteSectionValidators,
} from '@/features/website-builder/builder/validation/websiteSectionValidators'
import { FormBuilder } from '@/forms'
import EditorLayout from '@/lib/builder/public/editor/EditorLayout.vue'
import { OwnButton } from '@/ui/OwnButton'
import { OwnInput } from '@/ui/OwnInput'
import { OwnInputContainer } from '@/ui/OwnInputContainer'
import { OwnTextarea } from '@/ui/OwnTextarea'

import { featureIcons } from '../../../common/feature-icons'

const MAX_DESCRIPTION_LENGTH = 200
const MAX_TITLE_LENGTH = 50

export default {
  name: 'FeatureDetailEditor',
  components: {
    EditorLayout,
    IconPicker,
    OwnButton,
    OwnInput,
    OwnInputContainer,
    OwnTextarea,
  },
  mixins: [
    FormBuilder({
      description: {
        debounce: 250,
        validateOnInit: true,
        validators: [
          WebsiteSectionValidators.maxLength(MAX_DESCRIPTION_LENGTH),
        ],
      },
      icon: {
        debounce: 250,
        validateOnInit: true,
        validators: [WebsiteSectionValidators.required],
      },
      title: {
        debounce: 250,
        validateOnInit: true,
        validators: [
          WebsiteSectionValidators.required,
          WebsiteSectionValidators.maxLength(MAX_TITLE_LENGTH),
        ],
      },
    }),
  ],
  props: {
    item: { type: Object, required: true },
  },
  emits: ['update', 'back'],
  setup() {
    const { t } = useI18n()

    return { t, websiteSectionMaxChars }
  },
  data() {
    return {
      MAX_DESCRIPTION_LENGTH,
      MAX_TITLE_LENGTH,
      icons: featureIcons,
    }
  },
  created() {
    const { item } = this

    this.setInitialFormValues({
      description: item.description,
      icon: item.icon,
      title: item.title,
    })
  },
  methods: {
    onFormValuesUpdate(formValues) {
      this.$emit('update', formValues)
    },
  },
}
</script>
